import { useState } from 'react';
import { Section, Eyebrow, Heading, Cta } from './home-ui';

export default function Faq({ data }) {
    const items = data || [];
    const [open, setOpen] = useState(1); // second item open by default (HANDOFF §5)
    if (!items.length) return null;

    return (
        <Section id="faq" bg="alt">
            <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.8fr_1.2fr]">
                <div>
                    <Eyebrow>FAQ</Eyebrow>
                    <Heading line1="Question?" line2="Quick answers." className="mt-4" />
                    <p className="mt-4 text-ink-muted">Keep FAQs short on the homepage. The detailed articles live on separate pages.</p>

                    <div className="mt-6 rounded-card bg-white p-6">
                        <div className="text-2xl">💬</div>
                        <h3 className="mt-3 font-display text-lg font-bold text-navy">You have a different question?</h3>
                        <p className="mt-2 text-sm text-ink-muted">Send the address and the issue. We answer with the likely next step, not a sales pitch.</p>
                        <Cta label="Contact Us" href="#contact" className="mt-4" />
                    </div>
                </div>

                <div className="space-y-3">
                    {items.map((f, i) => {
                        const isOpen = open === i;
                        return (
                            <div key={f.id || i} className={`overflow-hidden rounded-card border transition ${isOpen ? 'border-navy bg-navy text-white' : 'border-surface-line bg-white'}`}>
                                <button type="button" onClick={() => setOpen(isOpen ? -1 : i)}
                                    className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left">
                                    <span className={`font-display font-semibold ${isOpen ? 'text-white' : 'text-navy'}`}>{f.question}</span>
                                    <span className={`text-2xl leading-none ${isOpen ? 'text-white' : 'text-brand'}`}>{isOpen ? ', ' : '+'}</span>
                                </button>
                                {isOpen && <div className="px-6 pb-6 -mt-1 text-white/85">{f.answer}</div>}
                            </div>
                        );
                    })}
                </div>
            </div>
        </Section>
    );
}
